import { render, staticRenderFns } from "./tabbar-common.vue?vue&type=template&id=76b8f037&scoped=true"
import script from "./tabbar-common.vue?vue&type=script&lang=js"
export * from "./tabbar-common.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b8f037",
  null
  
)

export default component.exports